<template>
  <crud-delete
    :open="open"
    :loading="loading"
    :title="title"
    :errorMessage="errorMessage"
    @delete="remove"
    @close="$emit('close')"
  >
    <p>{{ $t('common.confirmDelete') }}: <strong>{{ item.nombre }}</strong></p>
  </crud-delete>
</template>

<script>
import OfertaProvider from "../../../providers/OfertaProvider";
import { CrudDelete } from "@dracul/common-frontend";
import ClientError from "@/errors/ClientError";

export default {
  name: "OfertaDelete",
  components: { CrudDelete },
  props: {
    open: { type: Boolean, default: true },
    item: { type: Object, required: true },
  },
  data() {
    return {
      title: "oferta.deleting",
      errorMessage: "",
      loading: false,
    };
  },
  methods: {
    remove() {
      this.loading = true;
      OfertaProvider.deleteOferta(this.item.id)
        .then((r) => {
          if (r) {
            this.$emit("itemDeleted", r.data.ofertaDelete);
            this.$emit("close");
          }
        })
        .catch((error) => {
          let clientError = new ClientError(error);
          this.errorMessage = clientError.i18nMessage;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>

